import { Pipe, PipeTransform } from '@angular/core'
import { AUTHORIZATION_STATUS } from '@mmx/shared'

function getStatusMap(): Record<string, AUTHORIZATION_STATUS> {
  return {
    A1: AUTHORIZATION_STATUS.APPROVED,
    A2: AUTHORIZATION_STATUS.PARTIALLY_APPROVED,
    A3: AUTHORIZATION_STATUS.DENIED,
    A4: AUTHORIZATION_STATUS.INITIATED_CASE_INSURANCE,
    A6: AUTHORIZATION_STATUS.PEER_REVIEW,
    C: AUTHORIZATION_STATUS.CANCELLED,
    CT: AUTHORIZATION_STATUS.PEER_REVIEW,
    NA: AUTHORIZATION_STATUS.NOT_REQUIRED,
    51: AUTHORIZATION_STATUS.COMPLETED,
    71: AUTHORIZATION_STATUS.EXPIRED,
  }
}

@Pipe({
  name: 'serviceReviewStatusToAuthStatus',
  standalone: false,
})
export class ServiceReviewStatusToAuthStatusPipe implements PipeTransform {
  transform(statusCode?: string) {
    return getStatusMap()[statusCode]
  }
}

@Pipe({
  name: 'serviceReviewStatusToAuthStatusText',
  standalone: false,
})
export class ServiceReviewStatusTextToAuthStatusPipe implements PipeTransform {
  transform(statusCode?: string) {
    const status = getStatusMap()[statusCode]
    return status ? `statuses.authorizations.${status}` : statusCode
  }
}
